import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import DotSvg from '../../../svg/DotSvg';
import CrossArrow from '../../../svg/CrossArrow';
import Delete from '../../../svg/Delete';
import { setWholeFocusMusic } from '../../../store/focuspage/focuspageSlice';
import { deleteFocusMusicThunk, getDataForFocusThunk } from '../../../store/focuspage/focuspageThunk';
import { setDeleteAlert } from '../../../store/alert/alertSlice';
import EditIcon from '../../../svg/EditSvg';

export default function MusicRedirectCard({ txt, link, dotimgclss, item, isDelete }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const token = localStorage.getItem('dizeeToken');
    useEffect(() => {
        dispatch(getDataForFocusThunk({ token: token }))
    }, [])

    console.log(`item::`, item);

    // Add this handler function with the other handlers
    const handleMusicEditClick = () => {
        navigate('/focus-page/music-type/edit-single', {
            state: {
                musicData: item
            }
        });
    };

    const handleMusicEditClick1 = () => {
        navigate('/focus-page/music-type/edit-multiple', {
            state: {
                musicData: item
            }
        });
    };

    return (
        <div className='p-4 py-6 flex w-full justify-between items-center'>
            <div className='flex items-center'>
                <span className='text-white'>{txt}</span>
                {dotimgclss && (

                    <DotSvg width={6} height={6} color={'red'} className='ml-2' />

                )}
            </div>
            <div className="flex flex-row items-center gap-x-[15px]">
                <button onClick={() => {
                    dispatch(setWholeFocusMusic(item))
                    navigate(link)
                }} >
                    <CrossArrow className='h-[14px] w-[14px]  cursor-pointer' />
                    {/* <img src={plus} alt='plus'  /> */}
                </button>
                <button onClick={() => {
                    if (link == '/focus-page/music-page') {
                        handleMusicEditClick()
                    } else {
                        handleMusicEditClick1()
                    }
                }} >
                    <EditIcon className='h-[14px] w-[14px]  cursor-pointer' />
                </button>
                {
                    isDelete &&
                    <button onClick={() => {
                        dispatch(setDeleteAlert({
                            type: 'music',
                            data: {
                                token, payload: {
                                    ...item
                                }
                            }
                        }));
                    }} >
                        {/* <CrossArrow className='h-[14px] w-[14px]  cursor-pointer' /> */}
                        <Delete className='h-[14px] w-[14px]  cursor-pointer' />
                    </button>
                }
            </div>

        </div>
    );
}
